import { FlexProps } from '@chakra-ui/react';
import { formatCurrency } from '@monetize/utils/core';
import { MFlex, MText } from '../../../components/Monetize';

interface IPastDueInfoProps extends FlexProps {
  pastDueAmount: number;
  currency: string;
}
const PastDueAmountInfo = ({
  pastDueAmount,
  currency,
  ...rest
}: IPastDueInfoProps) => {
  if (pastDueAmount <= 0) {
    return null;
  }
  return (
    <MFlex {...rest} gap={1}>
      <MText color="tRed.base" fontWeight="semibold">
        Past Due:
      </MText>
      <MText color="tRed.base">
        {formatCurrency(pastDueAmount, {
          currency,
          maximumFractionDigits: 2,
        })}
      </MText>
    </MFlex>
  );
};

export default PastDueAmountInfo;
